import React from 'react'
import styled from 'styled-components'
import Flex from 'UIKit/Box/Flex'
import Text from 'UIKit/Text'
import { Trans } from 'react-i18next'
import Button from 'UIKit/Button'
import { Icons } from 'svgs'
import { colors } from 'theme/colors'
import { border, BorderProps } from 'styled-system'
import { useAppDispatch, useAppSelector } from 'state'
import Box from 'UIKit/Box/Box'
import { clearSearchHistory, removeSearchHistoryText } from 'state/session/actions'

type SearchHistoryProps = { onChangeText: (text: string) => void }

const SearchHistory: React.FC<SearchHistoryProps> = ({ onChangeText }) => {
  const dispatch = useAppDispatch()
  const history = useAppSelector((state) => state.session.searchHistory)

  return (
    history?.length > 0 && (
      <Box id="searchhistory" padding={['0px 12px', '', '0px']} mt={['12px', '12px', '18px']}>
        <Flex alignItems="center" justifyContent="space-between">
          <Text small color="textSubtle" bold>
            <Trans>Search History</Trans>
          </Text>
          <StyledSearchBadgeButton
            id="clear"
            border={`1px solid ${colors.strokeAlt}`}
            onClick={() => dispatch(clearSearchHistory())}
          >
            <Icons.BinIcon width="20px" height="20px" fill={colors.textSubtle} />
          </StyledSearchBadgeButton>
        </Flex>

        <Flex flexWrap="wrap">
          {history.slice(0, 6).map((text) => (
            <StyledSearchBadgeButton
              mt="12px"
              key={text}
              mr="12px"
              onClick={() => {
                onChangeText(text)
              }}
              id="item-select"
            >
              <Flex alignItems="center">
                <Text small mr="8px" color="textSubtle">
                  {text}
                </Text>
                <Box
                  id="item-remove"
                  onClick={(e) => {
                    dispatch(removeSearchHistoryText({ text }))
                    e.stopPropagation()
                  }}
                >
                  <Icons.CloseStrokeIcon fill={colors.textSubtle} width="20px" />
                </Box>
              </Flex>
            </StyledSearchBadgeButton>
          ))}
        </Flex>
      </Box>
    )
  )
}

const StyledSearchBadgeButton = styled(Button)<BorderProps>`
  background: ${({ theme }) => theme.colors.cardBackground};
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
  height: 36px;
  font-size: 14px;
  box-sizing: border-box;
  padding: 0px 12px;

  ${border}

  & svg:hover {
    fill: ${({ theme }) => theme.colors.text};
  }
`

export default React.memo(SearchHistory)
